const NumberFormatComma = (amount: number) => {
  return amount.toLocaleString();
};

export default NumberFormatComma;
